<template>
    <div class="rv-create p-0">
        <div class="title p-3 border-bottom border-primary fw-600" v-if="$detect == 'web'">
            Sửa danh mục
        </div>
        <div :class="{
                'body': true,
                'p-3': $detect == 'web'
            }">
            <titleCreate
                :data.sync="form.name"
                :error.sync="error.name"/>
            <category
                :suggest="suggestCategory"
                :data.sync="form.category"
                :error.sync="error.category"
                />

            <div class="mt-4 content">
                <div class="btn-container">
                    <span class="mb-2 fs-14px mr-3">Trạng thái</span>
                    <label class="switch">
                        <input type="checkbox" checked v-model="form.status">
                        <span class="slider round"></span>
                    </label>

                </div>
            </div>
            <div class="mt-4 content">
                <p class="mb-2 fs-14px">Nội dung:</p>
                <editor :content.sync="form.description"/>
                <p class="mb-0 fs-14px text-note-img mt-1">* Nhập nội dung đầy đủ, đa dạng thì bài đăng sẽ xuất hiện ở nhiều công cụ tìm kiếm và người dùng dễ dàng tiếp cận hơn.</p>
                <div class="text-danger fs-12px mt-1" v-if="error.description">{{error.description}}</div>
            </div>
            <div style="height: 80px;" v-if="$detect == 'mobile'"></div>
            <div :class="{
                    'confirm mt-4 text-center': true,
                    'p-3 confirm-mobile fixed-bottom bg-white': $detect == 'mobile'
                }">
                <button type="button" class="btn btn-primary"
                    :disabled="loading" @click="submit()">Đăng tin</button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "EditCategory",
    components: {
        category: () => import('@/components/profile/create/categoryNew.vue'),
        editor: () => import('@/components/editor/index'),
        titleCreate: () => import('@/components/profile/create/title')
    },
    data() {
        return {
            imgPrimary: false,
            catName: '',
            id: this.$route.params.id,
            exclusive : null,
            iCat : 0,
            form: {
                name: '',
                category: '',
                description: '',
                status: 1
            },
            checkChangeCategory: true,
            arrSizeColor : [],
            error: {},
            suggestCategory: [],
            loading: false,
        }
    },
    created() {
        this.$store.state.title = 'Sửa danh mục';
        // apiGet('/v2/products/get_product',{iPro : this.id}).then(res => {
        //     let product = res.data;
        //     this.form.name = product.name;
        //     this.form.description = product.description;
        //     this.form.category = product.cat_id;
        //     this.form.status = res.picture_main;
        // })
    },
    methods: {
        async submit(){
            if(this.loading) return;
            this.loading = true;
            this.error = {};
            let form = {};
            form.name = this.form.name;
            form.iCat = this.form.category;
            form.description = this.form.description;
            form.status = this.form.status;

            await apiPut('/v2/profile/products/edit', {form}).then(res => {
                if(res.data.status == 1){
                    this.$message({
                        message: 'Cập nhật sản phẩm thành công!',
                        type: 'success',
                        center: true,
                    });
                    this.$router.push({
                        name: 'product-create-step2',
                        params: {
                            id: this.id
                        }
                    })
                }else{
                    this.error = res.data.msg;
                    this.$message({
                        message: 'Vui lòng kiểm tra lại các trường',
                        type: 'warning',
                        center: true,
                    });
                }
            }).catch(err => {
                if(err.status == 422){
                    this.error = err.data;
                    this.$message({
                        message: 'Vui lòng kiểm tra lại các trường',
                        type: 'warning',
                        center: true,
                    });
                }
            });

            this.loading = false;
        },
    }
};
</script>
<style lang='scss'>
    .switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
    .box-btn-x{
         width: calc(50% - 4px);
    }
    .btn_rdo{
        display: inline-block;
        background: #ccc;
        border-radius: 3px;
        color: #fff;
        height: 50px;
        line-height: 48px;
        opacity: 1;
        text-align: center;
        /*width: calc(50% - 4px);*/
        width: 110px;
        border: 1px solid #ccc;
        transition: all .3s;
        box-sizing: border-box;
        position: relative;
        font-weight: 700;
        margin-top: 0;
        font-size: 16px;
        &.btn_rdo_call{
            background: #33a837;
            border: 1px solid #33a837;
        }
        &.btn_rdo_buy{
            background: #f44f00;
            border: 1px solid #f44f00;
        }
    }
    .call-or-buy{
        padding: 11px 0;
        /*border-radius: 4px;*/
        border-top: 1px solid #007bff;
        /*border-bottom: 1px solid #007bff;*/


        .buy-call{
            top: -13px;
            padding: 0 10px;
            background: #fff;
            margin-left: 10px;
            color: #007bff;
        }
    }
    .product{
        .type{
            width: calc(50% - 4px);
        }
    }
    .min-quantity,.unit, .quality{
        width: calc(50% - 4px);

    }
    .min-quantity,.quality {
        margin-left: 8px;
    }
    input {
        box-shadow: none !important;
        -webkit-appearance: none;
    }
    .rv-create {
        .body {
            .confirm {
                button {
                    padding: 8px 60px !important;
                }
            }
            .confirm-mobile {
                box-shadow: 0 -3px 6px rgba(0,0,0,0.16), 0 -2px 4px rgba(0,0,0,0.12);
                button {
                    width: 100%;
                }
            }
        }
    }
    .rv-valiadate-input-form {
        input {
            border: 1px solid #dc3545 !important;
        }
        label {
            color: #dc3545 !important;
        }
    }
    .input-focus-effect {
        position: relative;
        display: flex;
        flex-direction: column-reverse;
        input {
            padding: 10px;
            border: 1px solid rgba(0, 0, 0, 0.2);
            display: block;
            width: 100%;
            border-radius: 4px;
            transition: border 0.15s linear;
            background-color: transparent;
            outline: none;
            &:focus {
                border-color: #007bff;
            }
            &:focus + label {
                transform: translateY(0);
                top: -13px;
                color: #007bff;
                background: #fff;
                padding: 0 10px;
                font-size: 14px;
                margin-left: -5px;
            }
        }
        label {
            position: absolute;
            top: 50%;
            left: 1rem;
            transform: translateY(-50%);
            pointer-events: none;
            color: #999;
            transition: 0.15s linear;
            font-size: 16px;
        }
        .input-on-alue {
            transform: translateY(0) !important;
            top: -13px !important;
            color: #007bff !important;
            background: #fff !important;
            padding: 0 10px !important;
            font-size: 14px !important;
            margin-left: -5px !important;
        }
    }
</style>
